import React, { useState, useEffect } from 'react';
import { FaTimes, FaExclamationTriangle, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';
import './index.css';

const TempAlert = ({ 
  type = 'error', 
  title, 
  message, 
  details = null,
  isVisible = false, 
  onClose, 
  autoClose = true,
  autoCloseDelay = 5000 
}) => {
  const [isShown, setIsShown] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsShown(true);
      setIsClosing(false);
      
      if (autoClose) {
        const timer = setTimeout(() => {
          handleClose();
        }, autoCloseDelay);
        
        return () => clearTimeout(timer);
      }
    }
  }, [isVisible, autoClose, autoCloseDelay]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsShown(false);
      if (onClose) onClose();
    }, 300); // Match the CSS transition duration
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="temp-alert-icon temp-alert-icon-success" />;
      case 'warning':
        return <FaExclamationTriangle className="temp-alert-icon temp-alert-icon-warning" />;
      case 'info':
        return <FaInfoCircle className="temp-alert-icon temp-alert-icon-info" />;
      case 'error':
      default:
        return <FaExclamationTriangle className="temp-alert-icon temp-alert-icon-error" />;
    }
  };

  const getAlertClass = () => {
    return `temp-alert temp-alert-${type} ${isShown ? 'temp-alert-show' : ''} ${isClosing ? 'temp-alert-hide' : ''}`;
  };

  if (!isShown) return null;

  return (
    <div className={getAlertClass()}>
      <div className="temp-alert-content">
        <div className="temp-alert-header">
          {getIcon()}
          <div className="temp-alert-title-section">
            <h6 className="temp-alert-title">{title}</h6>
            <button 
              className="temp-alert-close-btn" 
              onClick={handleClose}
              aria-label="Close alert"
            >
              <FaTimes />
            </button>
          </div>
        </div>
        
        <div className="temp-alert-body">
          <p className="temp-alert-message">{message}</p>
          
          {details && (
            <div className="temp-alert-details">
              {details.job && (
                <div className="temp-alert-detail-item">
                  <strong>Job:</strong> {details.job}
                </div>
              )}
              {details.code && (
                <div className="temp-alert-detail-item">
                  <strong>Code:</strong> {details.code}
                </div>
              )}
              {details.status && (
                <div className="temp-alert-detail-item">
                  <strong>Status:</strong> {details.status}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TempAlert; 